import * as React from 'react';
import { useState, useEffect } from 'react';
import { Radio, InputNumber, Modal, Form, message } from 'antd';
import './index.less';
import { postRedPacketRecharge, getCalcPrice } from '../../api/recharge';
import { toFen } from '../../utils/tools';

const options = [
  {
    value: 5000,
    label: '50元',
  },
  {
    value: 10000,
    label: '100元',
  },
  {
    value: 30000,
    label: '300元',
  },
];

const SELF_NUM_TYPE = 1;
const MAX_NUM = 100000;

const block = (element?: string, modifier?: string) => `recharge-modal${element ? '__' + element : ''}${modifier ? '--' + modifier : ''}`;

const RechargeModal: React.FC<{
  values: {
    rechargeAmount: {
      amount?: number | null;
      otherAmount?: number | null;
    };
    needInvoice: boolean;
  };
  visible: boolean;
  onConfirm?: (values?: any) => void;
  onCancel: () => void;
  onChange?: (values) => void;
}> = ({ values, visible, onCancel, onChange = values => console.log(values) }) => {
  //   const { rechargeAmount, needInvoice } = values;
  //   const { amount, otherAmount } = rechargeAmount || {};

  //   const [value, setValue] = useState<any>(options[0].value);

  //   // 获取实际的支付金额
  //   const handleGetChargePrice = (_val?: number) => {
  //     getCalcPrice(_val).then(data => {
  //       console.log(data, 'data');
  //     });
  //   };

  //   useEffect(() => {
  //     handleGetChargePrice(value === SELF_NUM_TYPE ? 0 : value);
  //   }, [value]);

  const [price, setPrice] = useState(0);

  const [value, setValue] = useState<any>(options[0].value);
  const [inputVal, setInputVal] = useState(0);

  const handleChange = e => {
    if (e.target.value !== SELF_NUM_TYPE) {
      setInputVal(0);
    }
    setValue(e.target.value);
  };

  // 获取实际的支付金额
  const handleGetChargePrice = (_val?: number) => {
    getCalcPrice(_val).then(data => {
      if (data) {
        setPrice((data as any).price / 100);
      }
    });
  };

  useEffect(() => {
    handleGetChargePrice(value === SELF_NUM_TYPE ? 0 : value);
  }, [value]);

  const handleInputFocus = () => {
    if (value === 1) return;
    setValue(1);
    setPrice(0);
  };

  // TODO 做防抖
  const handleChangeInput = (value: number) => {
    if (Number.isNaN(Number(value))) {
      setPrice(0);
      return;
    }
    setInputVal(value);
    handleGetChargePrice(Number(value * 100));
  };

  const handleConfirm = () => {
    if (value === SELF_NUM_TYPE && inputVal === 0) {
        message.warning(`请输入(1~${MAX_NUM})之间的整数`);
        return;
    }
    if (value === SELF_NUM_TYPE && inputVal > MAX_NUM) {
        message.warning(`请输入(1~${MAX_NUM})之间的整数`);
      return;
    }

    let realVal = 0;
    if (value === SELF_NUM_TYPE) {
      realVal = inputVal * 100;
    } else {
      realVal = value;
    }

    postRedPacketRecharge({
      retUrl: window.location.href,
      amount: realVal,
      invoice: false, // values.needInvoice,
    }).then(data => {
        if(data) {
            window.open(`/v3/individuals/payment?orderId=${(data as any).orderId}`);
        }
    });
  };

  return (
    <Modal title="红包钱包充值" visible={visible} onOk={handleConfirm} onCancel={onCancel} className={block()} cancelText="取消" okText="确定">
      <div className={block('row')}>
        <div>充值方式：</div>
        <img src="//pic.kuaizhan.com/g3/a2/fd/7ad2-61d3-419e-b57c-a4538ecf984878/imageView/v1/thumbnail/110x42" className={block('alipay')} />
      </div>
      <div className={block('row')}>
        <div>充值数额：</div>
        <div>
          <Radio.Group onChange={handleChange} value={value}>
            {options.map(item => (
              <Radio value={item.value} key={item.label}>
                {item.label}
              </Radio>
            ))}
            <Radio value={SELF_NUM_TYPE}>
              <span style={{ marginRight: '10px' }}>其他</span>
              <InputNumber
                min={0}
                // max={MAX_NUM}
                value={inputVal}
                onChange={handleChangeInput}
                onFocus={handleInputFocus}
              />
              <span className={block('tip')}>请输入(1~{MAX_NUM})之间的整数</span>
            </Radio>
          </Radio.Group>
        </div>
      </div>
      <div className={block('row')}>
        <div>应付金额：</div>
        <div>{price}元</div>
      </div>
    </Modal>
    //     <Modal
    //         title='红包钱包充值'
    //         style={{ fontSize: '14px', color: '#757575'}}
    //         visible={visible}
    //         onOk={() => handleRecharge(values)}
    //         onCancel={onCancel}
    //         className={clsPrefix}
    //     >
    //         <Form
    //             layout='horizontal'
    //             labelCol={{ span: 4 }}
    //             wrapperCol={{ span: 16 }}
    //         >
    //             <Form.Item key='way' label='充值方式:'>
    //                 <img src='//pic.kuaizhan.com/g3/a2/fd/7ad2-61d3-419e-b57c-a4538ecf984878/imageView/v1/thumbnail/110x42' className={`${clsPrefix}__alipay`} />
    //             </Form.Item>
    //             <Form.Item key='rechargeAmount' label='充值数额:'>
    //                 <div>
    //                     <Radio.Group
    //                         value={otherAmount ? null : amount}
    //                         onChange={(e) => {
    //                             console.log(e)
    //                             onChange({ rechargeAmount: { amount: e.target.value, otherAmount: '' }})
    //                         }}
    //                         options={options}
    //                     />
    //                     <Radio onClick={() => onChange({rechargeAmount : {...rechargeAmount, amount: null} })} checked={!amount} style={{ marginTop: '10px' }}>
    //                     <div style={{ display: 'inline-flex', alignItems: 'center', whiteSpace: 'nowrap' }}>
    //                         其他
    //                         <InputNumber
    //                             max={100000}
    //                             min={1}
    //                             value={amount == null ? otherAmount : undefined}
    //                             onChange={(num) => {
    //                                 onChange({rechargeAmount: {...rechargeAmount, otherAmount: num }})
    //                             }}
    //                             style={{ margin: '0 5px' }}
    //                         />
    //                         元
    //                         <span className={`${clsPrefix}__recharge-tip`}>请输入(1 ~ 100000)之间的整数</span>
    //                     </div>
    //                     </Radio>

    //                 </div>
    //             </Form.Item>
    //             <Form.Item key='payAmount' label='应付金额:'>
    //                 <span>
    //                     <span className={`${clsPrefix}__money`}>{amount || otherAmount || 0}</span>
    //                     元
    //                 </span>
    //             </Form.Item>
    //             <Form.Item key='needInvoice' label='开具发票:'>
    //                 <Radio.Group
    //                     options={[{
    //                         value: false,
    //                         label: '不需要'
    //                     }, {
    //                         value: true,
    //                         label: '需要'
    //                     }]}
    //                     value={needInvoice}
    //                     onChange={e => {
    //                         console.log(e)
    //                         onChange({ needInvoice: e.target.value })
    //                     }}
    //                 />
    //             </Form.Item>
    //         </Form>
    //     </Modal>
  );
};

export default RechargeModal;
